module.exports = __webpack_public_path__ + "static/media/emoticon-emotion-face-silent-smiley-svgrepo-com.8e5a6442.svg";